var BST;
(function (BST) {
  var SettingCar = BST.SettingCar = (function () {
    function SettingCar (parent, options) {
      var _self = this;

      parent = parent || 'body';
      var opt = this.opt = options || {};
      this._callbackCreate = opt.callbackCreate;
      this._callbackUpdate = opt.callbackUpdate;
      this._callbackDelete = opt.callbackDelete;

      this.create(parent);
      this.createTable([], [], [], []);
    }

    SettingCar.prototype.setData = function (datas, orgs, types, recs) {
      this._datas = datas || [];
      this._orgs = orgs || [];
      this._types = types || [];
      this._recs = recs || [];
    };

    SettingCar.prototype.create = function (parent) {
      var _self = this;

      var base = this.base = $('<div>').addClass('setting-car').appendTo(parent);

      var header = $('<div>').addClass('header').appendTo(base);

      var row1 = $('<div>').addClass('row').appendTo(header);
      this.btnNew = $('<span>').addClass('btn-new').text('新規作成').appendTo(row1)
        .on('click', function () {
          if (_self._callbackCreate) _self._callbackCreate(_self._orgs, _self._types, _self._recs);
        });
      $('<span>').addClass('label').html('車両設定').appendTo(row1);
      // this.dcnum = $("<div>").addClass("count").html("登録済ドライバー数&nbsp" + "-" + "名（上限" + "-" + "名）").appendTo(row1);

      var row2 = $('<div class="row"> ').appendTo(header);
      $("<input type='password' name='dummypass' style='visibility: hidden; position: absolute;' />").addClass('search').appendTo(row2);
      this.search = $('<input>').addClass('search').attr('autocomplete', 'off').attr('placeholder', 'フリーワード検索').appendTo(row2);
    };

    // テーブル作成
    SettingCar.prototype.createTable = function (cars, orgs, types, recs) {
      var _self = this;

      // テーブル
      if (!this.table) {
        this.table = $('<table>').addClass('table').appendTo(this.base);
      } else {
        this.table.empty();
      }
      var table = this.table;
      var header = $('<thead>').addClass('scrollHead').appendTo(table);
      var tr = $('<tr> ').appendTo(header);
      $('<td>').addClass('col0').addClass('label0').text('').appendTo(tr);
      $('<td>').addClass('col1').addClass('label').text('所属拠点').appendTo(tr);
      $('<td>').addClass('col2').addClass('label').text('車両形状').appendTo(tr);
      $('<td>').addClass('col3').addClass('label').text('ドライブレコーダー').appendTo(tr);
      $('<td>').addClass('col4').addClass('label').text('車両名').appendTo(tr);
      $('<td>').addClass('col5').addClass('label').text('').appendTo(tr);

      // ハッシュ
      var orgMap = {};
      for (var i = 0; i < orgs.length; i++) {
        orgMap[orgs[i].cd] = orgs[i];
      }

      var typeMap = {};
      for (i = 0; i < types.length; i++) {
        typeMap[types[i].id] = types[i];
      }
      var recMap = {};
      for (i = 0; i < recs.length; i++) {
        recMap[recs[i].cd] = recs[i];
      }

      var body = $('<tbody>').addClass('scrollBody').appendTo(table);
      // 1行分
      for (i = 0; i < cars.length; i++) {
        var d = cars[i];

        // 所属
        var org = orgMap[d.ocd] || { nm: '' };
        // 車両形状
        var type = typeMap[d.type] || { nm: '' };
        // ドライブレコーダー
        var rec = recMap[d.rcd] || { nm: '' };

        tr = $('<tr class="tr"> ').data('data', d).appendTo(_self.table);
        $('<td>').addClass('col0').addClass('item').addClass('item0').text(i + 1).appendTo(tr);
        $('<td>').addClass('col1').addClass('item').text(org.nm).appendTo(tr);
        $('<td>').addClass('col2').addClass('item').text(type.nm).appendTo(tr);
        $('<td>').addClass('col3').addClass('item').text(rec.nm).appendTo(tr);
        $('<td>').addClass('col4').addClass('item').text(d.nm).appendTo(tr);

        var btns = $('<td>').addClass('col5').addClass('item').appendTo(tr);
        $('<span>').addClass('btn-edit').text('編集').appendTo(btns)
          .on('click', function () {
            var _d = $(this).parent().parent().data('data');
            if (_self._callbackUpdate) {
              _self._callbackUpdate(_d, _self._orgs, _self._types, _self._recs);
            }
          });
        $('<span>').addClass('btn-delete').text('削除').appendTo(btns)
          .on('click', function () {
            var _d = $(this).parent().parent().data('data');
            if (_self._callbackDelete) {
              _self._callbackDelete(_d);
            }
          });
      }// end of for

      if (cars.length > 0) {
        this.table.exTableFilter(this.search
          , {
            onFilteringEnd: function (api) {
              _self.resetNumber();
            }
          }
        );
      }
      this.search.trigger('change');
    };

    SettingCar.prototype.update = function (cars, orgs, types, recs) {
      this.setData(cars, orgs, types, recs);
      this.createTable(cars, orgs, types, recs);
    };

    SettingCar.prototype.resetNumber = function () {
      var no = 1;

      this.table.find('.scrollBody').find('.tr').each(function (i, elem) {
        var $tr = $(elem);

        // console.debug($tr.css('display'));
        if ($tr.css('display') !== 'none') {
          var $no = $tr.find('.col0');
          $no.text(no);
          no++;
        }
      });
    };

    SettingCar.prototype.disp = function (b) {
      if (b) {
        this.base.show();
      } else {
        this.base.hide();
      }
    };

    return SettingCar;
  })();
})(BST || (BST = {}));
